(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-per-wear"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const detail = event.detail || {};
    const variant = detail.resource;
    const productId = detail.data && detail.data.productId;

    if (!productId) return;

    for (const element of document.querySelectorAll('.wuka-ppw')) {
      if (element.dataset.productId !== String(productId)) continue;

      const valueElement = element.querySelector('[data-ppw-value]');
      if (!valueElement) continue;

      let count = Number.parseInt(element.dataset.tagCount, 10) || 0;
      const packIndex = Number.parseInt(element.dataset.packIndex, 10);
      if (packIndex >= 0 && Array.isArray(variant?.options)) {
        const match = String(variant.options[packIndex] || '').match(/^(\d+)/);
        count = match ? Number.parseInt(match[1], 10) : Number.parseInt(element.dataset.tagCount, 10) || 0;
      }

      if (!count || typeof variant?.price !== 'number') {
        element.querySelector('price-per-wear-info')?.closeTooltip();
        element.hidden = true;
        valueElement.textContent = '';
        continue;
      }

      if (element.dataset.gbp !== '1') continue;

      const wearsPerPair = Number.parseInt(element.dataset.wearsPerPair, 10) || 50;
      const pence = Math.round(variant.price / (count * wearsPerPair));
      element.hidden = false;
      valueElement.textContent = pence < 100
        ? `≈${pence}${element.dataset.pencePerWearLabel}`
        : `≈${new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
          }).format(pence / 100)} ${element.dataset.perWearLabel}`;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
